export default "__VITE_ASSET__7fab57fd__"